// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","caption":"caption-2NY3u","align--left":"align--left-1XKzd","align--right":"align--right-OZdRM","align--center":"align--center-3L2DM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/shared/Caption/_caption.css
// module id = 1175
// module chunks = 1